import { injectable } from 'inversify';
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { CommandRegistry } from '../../../concepts/commands/CommandRegistry';
import { resolve } from '../../Container';
import { CommandScript } from './CommandScript';


export type CommandScriptVerifyResult = readonly [true] | readonly [false, string];
const okResult = Object.freeze([true]) as readonly [true];

@injectable()
export class CommandInterpreter {

    @resolve(CommandDispatcher) private dispatch!: CommandDispatcher;
    @resolve(CommandRegistry) private registry!: CommandRegistry;

    public verify(cs: CommandScript): CommandScriptVerifyResult {
        const { registry } = this;

        for (const [name] of cs) {
            if (!registry.get(name)) return [false, `${name} is not a valid command.`];
        }

        return okResult;
    }

    public async exec(cs: CommandScript) {
        const { dispatch, registry } = this;

        for (const [name, args] of cs) {
            const command = registry.get(name);
            const result = dispatch(command, args);
            if (result instanceof Promise) {
                await result;
            }
        }
    }
}
